'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = spannify;
exports.despannify = despannify;

var _dictionary = require('./dictionary');

var _createWalker = require('./create-walker');

var _createWalker2 = _interopRequireDefault(_createWalker);

var _defs = require('./defs');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function spannify(root) {
  var walker = (0, _createWalker2["default"])(root);
  var nodes = [];

  while (walker.nextNode()) {
    nodes.push(walker.currentNode);
  }

  nodes.forEach(splitText);
  return despannify.bind(null, root);
}

function despannify(root) {
  var nodes = Array.prototype.slice.call(root.getElementsByClassName(_defs.POPUP_CLASS));
  var parents = nodes.map(function (node) {
    return node.parentNode;
  });
  nodes.forEach(function (node) {
    var text = node.childNodes[0];
    node.parentNode.replaceChild(text, node);
  });
  parents.forEach(function (parent) {
    return parent.normalize();
  });
}

function splitText(node) {
  var pos = 0;
  var lastTextNode = node;
  var fragments = node.data.split(/\b/);
  fragments.forEach(function (word) {
    if ((0, _dictionary.hasWord)(word)) {
      var nodeToReplace = lastTextNode.splitText(pos);
      lastTextNode = nodeToReplace.splitText(word.length);
      pos = 0;
      var span = document.createElement('span');
      span.className = _defs.POPUP_CLASS;
      span.appendChild(document.createTextNode(word));
      node.parentNode.replaceChild(span, nodeToReplace);
    } else {
      pos += word.length;
    }
  });
}